import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSmartwatch1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSmartwatch1"><Path fillRule="evenodd" clipRule="evenodd" d="M7.27995 1H16.7215L17.7215 4H20V20H17.7215L16.7215 23H7.27995L6.27995 20H4V4H6.27995L7.27995 1ZM8.38813 20L8.72147 21H15.2799L15.6133 20H8.38813ZM15.2799 3L15.6133 4H8.38813L8.72147 3H15.2799ZM13 8H11V12.4142L13.5 14.9142L14.9142 13.5L13 11.5858V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSmartwatch1;
